import React, { useEffect } from "react";
import "./BlogMain2.css";
import { useLocation } from "react-router-dom";
import { blogContent } from "../../Data/BlogData";
import NavComponent from "../../components/NavComponent";
import SEOHelmet from "../../components/SEOHelmet";

export const BlogMain2 = () => {
  const location = useLocation();
  const { state } = location;
  const BlogDetails = blogContent.find((item, index) => item.id === state);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="element">
      <SEOHelmet title={BlogDetails.title} />

      <NavComponent></NavComponent>
      <div className="container">
        {/* Header */}
        <header className="header">
          <h1 className="main-title">{BlogDetails.title}</h1>
        </header>

        {/* Content Wrapper - Now includes hero image and sidebar */}
        <div className="content-wrapper">
          {/* Left Column - Hero Image + Main Content */}
          <div className="main-column">
            {/* Hero Image */}
            <div className="hero-image">
              <img src={BlogDetails?.image} alt="Healthcare AI Technology" />
            </div>

            {/* Main Article */}
            <main className="main-content">
              {/* TL;DR Section */}

              {BlogDetails.sections.map((con, index) => {
                return (
                  <section key={index} className="section">
                    {con?.heading && (
                      <h2 className="section-title">
                        <span>{con?.heading || ""}</span>
                        <img
                          className="title-underline"
                          src="https://c.animaapp.com/memovagbcMSRxN/img/vector-1.svg"
                          alt=""
                        />
                      </h2>
                    )}
                    <p className="section-text">{con?.content || ""}</p>
                    <p className="section-text">
                      {con?.listHeading || ""}
                      <ul>
                        {con?.list?.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </p>
                    <p className="section-text">
                      {con?.afterListContent || ""}
                    </p>
                  </section>
                );
              })}

              <section className="section">
                <h2 className="section-title">
                  <span>Author</span>
                  <img
                    className="title-underline"
                    src="https://c.animaapp.com/memovagbcMSRxN/img/vector-1.svg"
                    alt=""
                  />
                </h2>
                <div className="author-card">
                  <img
                    className="author-avatar"
                    src={BlogDetails.author.image}
                    alt={BlogDetails.author.name}
                  />
                  <div className="author-info">
                    <h3 className="author-name">
                      {BlogDetails.author.name || ""}
                    </h3>
                    <p className="author-title">
                      {BlogDetails.author.role || ""}
                    </p>
                    <p className="author-bio">{BlogDetails.author.bio || ""}</p>
                  </div>
                </div>
              </section>

              {/* <section className="section">
                <h2 className="section-title">
                  <span>TL; DR</span>
                  <img
                    className="title-underline"
                    src="https://c.animaapp.com/memovagbcMSRxN/img/vector-1.svg"
                    alt=""
                  />
                </h2>
                <p className="section-text">
                  TL; DR Health claims, reimagined! Canvendor's Agentic AI
                  slashes delays, kills errors, and puts your claims on
                  autopilot. Fast. Smart. Hassle-free. The future of healthcare
                  claims is here! It's easy to get frustrated, whether you're at
                  the hospital front desk, in the billing office, or on the
                  insurance side of things. Delays, too much paperwork, and
                  constant back-and-forths make the whole process feel stuck in
                  the past. That's exactly why Canvendor created Agentic AI — to
                  make claims processing easier, more efficient, and faster.
                  This smart solution is designed to eliminate regulatory
                  roadblocks, reduce repetitive workload, and give your team the
                  freedom to focus on what truly matters: patient care.
                </p>
                <p className="section-text">
                  If you're involved in hospital operations, insurance claims,
                  or revenue cycle management, Agentic AI helps you:
                  <br />• Automate repetitive tasks
                  <br />• Accelerate claim approvals
                  <br />• Improve claim accuracy
                  <br />• Monitor every step in real time
                </p>
                <p className="section-text">
                  No more digging through forms or chasing down paperwork. Just
                  a clean, well-organized system that keeps everything flowing —
                  minus the stress
                </p>
              </section> */}

              {/* Problems Section */}
              {/* <section className="section">
                <h2 className="section-title">
                  <span>What's Holding Healthcare Claims Back?</span>
                  <img
                    className="title-underline"
                    src="https://c.animaapp.com/memovagbcMSRxN/img/vector-1.svg"
                    alt=""
                  />
                </h2>
                <p className="section-text">
                  Many healthcare providers still rely on outdated, manual
                  processes. That leads to a range of familiar problems:
                  <br />
                  <br />• Payment delays
                  <br />• Avoidable errors and data entry issues
                  <br />• Claims getting rejected or lost
                  <br />• Rising administrative costs
                  <br />• Constant compliance worries
                </p>
              </section> */}

              {/* Solution Section */}
              {/* <section className="section">
                <h2 className="section-title">
                  <span>Here's the Game-Changer: Canvendor's AI Agent</span>
                  <img
                    className="title-underline"
                    src="https://c.animaapp.com/memovagbcMSRxN/img/vector-1.svg"
                    alt=""
                  />
                </h2>
                <p className="section-text">
                  Think of the AI Agent as a dependable partner — one that knows
                  the ins and outs of healthcare claims and takes over the
                  tedious parts, so your staff doesn't have to.
                  <br />
                  Here's how it works:
                </p>
                <div className="feature-list">
                  <div className="feature-item">
                    <strong>Understands Claims Intelligently:</strong>{" "}
                    Automatically pulls important data from forms, bills, and
                    supporting documents.
                  </div>
                  <div className="feature-item">
                    <strong>Speeds Things Up:</strong> Detects and flags errors
                    quickly so claims move through the system faster.
                  </div>
                  <div className="feature-item">
                    <strong>Fits Into What You Already Use:</strong> Seamlessly
                    integrates with your existing software and workflows.
                  </div>
                  <div className="feature-item">
                    <strong>Always Audit-Ready:</strong> Tracks every step,
                    making compliance reporting easy and stress-free.
                  </div>
                </div>
              </section> */}

              {/* Benefits Section */}
              {/* <section className="section">
                <h2 className="section-title">
                  <span>Real Benefits You Can Measure</span>
                  <img
                    className="title-underline"
                    src="https://c.animaapp.com/memovagbcMSRxN/img/vector-1.svg"
                    alt=""
                  />
                </h2>
                <p className="section-text">
                  Switching to Agentic AI isn't just about convenience — it
                  brings measurable improvements across your organization:
                  <br />
                  <br />• Quicker Payments: Claims that used to take days can
                  now be processed in hours.
                  <br />• Improved Accuracy: Automated error checks reduce
                  rework and rejected submissions.
                  <br />• Reduced Costs: Less manual handling means more
                  efficient operations.
                  <br />• Happier Stakeholders: Patients and partners enjoy
                  faster service and better communication.
                  <br />• Live Visibility: Dashboards show what's working,
                  what's lagging, and where to focus next.
                </p>
              </section> */}

              {/* Why Canvendor Section */}
              {/* <section className="section">
                <h2 className="section-title">
                  <span>Why Canvendor?</span>
                  <img
                    className="title-underline"
                    src="https://c.animaapp.com/memovagbcMSRxN/img/vector-1.svg"
                    alt=""
                  />
                </h2>
                <p className="section-text">
                  At Canvendor, we don't just make tools — we understand the
                  real-world challenges that healthcare teams face.
                  <br />
                  That's why we designed Agentic AI with features that matter:
                  <br />• Easy to implement and use
                  <br />• Highly secure and scalable
                  <br />• Compatible with your current workflows — no major
                  overhauls required
                  <br />
                  It's smart automation that delivers — plain and simple.
                </p>
              </section> */}

              {/* CTA Section */}
              {/* <section className="section">
                <h2 className="section-title">
                  <span>Ready to Upgrade Your Claims Process?</span>
                  <img
                    className="title-underline"
                    src="https://c.animaapp.com/memovagbcMSRxN/img/vector-1.svg"
                    alt=""
                  />
                </h2>
                <p className="section-text">
                  Let Agentic AI show you what's possible when claims are done
                  the smart way.
                </p>
              </section> */}

              {/* Author Section */}
              {/* <section className="section">
                <h2 className="section-title">
                  <span>Author</span>
                  <img
                    className="title-underline"
                    src="https://c.animaapp.com/memovagbcMSRxN/img/vector-1.svg"
                    alt=""
                  />
                </h2>
                <div className="author-card">
                  <img
                    className="author-avatar"
                    src="https://c.animaapp.com/memovagbcMSRxN/img/ellipse-11.svg"
                    alt="Pon Vijaya Prabu"
                  />
                  <div className="author-info">
                    <h3 className="author-name">Pon Vijaya Prabu</h3>
                    <p className="author-title">UI/UX Designer - Canvendor</p>
                    <p className="author-bio">
                      TL; DR Health claims, reimagined! Canvendor's Agentic AI
                      slashes delays, kills errors, and puts your claims on
                      autopilot. Fast. Smart. Hassle-free.
                    </p>
                  </div>
                </div>
              </section> */}
            </main>
          </div>

          {/* Right Column - Sidebar */}
          <aside className="sidebar">
            {/* Contact Form */}
            <div className="sidebar-section-form">
              <h3 className="sidebar-title">Get In Touch</h3>
              <form className="contact-form">
                <input
                  type="text"
                  placeholder="Enter your name"
                  className="form-input"
                />
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="form-input"
                />
                <input
                  type="text"
                  placeholder="Subject"
                  className="form-input"
                />
                <textarea
                  placeholder="Enter your Message"
                  className="form-textarea"
                  rows="4"
                ></textarea>
                <button type="submit" className="form-submit">
                  Send Message
                </button>
              </form>
            </div>
            {/* Categories */}
            <div className="sidebar-section">
              <h3 className="sidebar-title">Categories</h3>
              <ul className="category-list">
                <li>
                  <a href="#" className="category-link">
                    AI/ ML Solutions
                  </a>
                </li>
                <li>
                  <a href="#" className="category-link">
                    Application Engineering
                  </a>
                </li>
                <li>
                  <a href="#" className="category-link">
                    Cloud Solution
                  </a>
                </li>
                <li>
                  <a href="#" className="category-link">
                    Digital Transformation
                  </a>
                </li>
                <li>
                  <a href="#" className="category-link">
                    Enterprise Solutions
                  </a>
                </li>
                <li>
                  <a href="#" className="category-link">
                    IT Consulting
                  </a>
                </li>
              </ul>
            </div>

            {/* Recent Posts */}
            <div className="sidebar-section">
              <h3 className="sidebar-title">Recent Post</h3>
              <div className="recent-posts">
                {[1, 2, 3, 4, 5, 6].map((index) => (
                  <div key={index} className="recent-post">
                    <img
                      src={`https://c.animaapp.com/memovagbcMSRxN/img/rectangle-11${
                        index > 1 ? `-${index - 1}` : ""
                      }.svg`}
                      alt="Post thumbnail"
                      className="post-thumbnail"
                    />
                    <div className="post-info">
                      <h4 className="post-title">
                        Assistant Manager – Finance
                      </h4>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Connect With Us */}
            <div className="sidebar-section">
              <h3 className="sidebar-title">Connect With Us</h3>
              <div className="social-links">
                {[
                  { alt: "Twitter", src: "mdi-twitter.svg" },
                  { alt: "LinkedIn", src: "mdi-linkedin-1.svg" },
                  { alt: "LinkedIn", src: "mdi-linkedin.svg" },
                  { alt: "Instagram", src: "lets-icons-insta.svg" },
                ].map((icon, i) => (
                  <div key={i} className="blog-social-icon-wrapper">
                    <img
                      className="blog-social-icon"
                      alt={icon.alt}
                      src={`https://c.animaapp.com/memsjwsrCRVpSp/img/${icon.src}`}
                    />
                  </div>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};
